<template>
  <div class="veda-product">
    <div class="web-box top">
      <a-row>
        <a-col :xs="24" :sm="12">
          <div style="max-width:460px;margin:0 auto">
            <h2>VEDA 移动营销平台</h2>
            <p>一站式程序化投放系统</p>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12">
          <div class="animo-wrap web-show">
            <img
              class="top-img"
              src="http://www.vedamobi.com/assets/website/images/mobile/top.png"
            />
            <div class="lightbeam lightbeam1"></div>
            <div class="lightbeam lightbeam2"></div>
            <div class="lightbeam lightbeam3"></div>
            <div class="lightbeam lightbeam4"></div>
          </div>
          <img
            class="top-img mobile-show"
            src="http://www.vedamobi.com/assets/website/images/mobile/top.png"
          />
        </a-col>
      </a-row>
    </div>
    <div class="label-wrap">
      <h4>VEDA移动营销平台</h4>
      <div></div>
      <p>移动广告程序化解决方案</p>
    </div>
    <div class="web-box content">
      <a-row>
        <a-col :xs="24" :sm="12">
          <img
            class="left"
            src="http://www.vedamobi.com/assets/website/images/mobile/content2.png"
          />
        </a-col>
        <a-col :xs="24" :sm="12">
          <div class="text-wrap right">
            <p class="text">
              对接优质流量媒体
              <br />- 快速对接流量需求方和供给方 <br />-
              高效稳定进行流量分发和竞价 <br />- VEDA DMP 精准定位营销人群
              <br />- 一站式稳定广告快速搭建方案
            </p>
            <p class="button" @click="goCallUs">联系我们</p>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="web-box content">
      <a-row>
        <a-col :xs="24" :sm="12">
          <div class="text-wrap left">
            <p class="text">
              快速搭建流量变现系统
              <br />- 支持API对接，接入方式灵活 <br />-
              提供代理方专属后台，实时数据清晰可控 <br />- 共享 VEDA
              媒体流量资源，轻松变现 <br />-
              提供行业专业培训，助力新进友商快速成长
            </p>
            <p class="button" @click="goCallUs">联系我们</p>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12">
          <img
            class="right"
            src="http://www.vedamobi.com/assets/website/images/mobile/content1.png"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import ScrollReveal from 'scrollreveal'
export default {
  data () {
    return {
      scrollReveal: ScrollReveal()
    }
  },
  components: {},
  mounted () {
    this.scrollReveal.reveal(`.left`, {
      // 动画的时长
      duration: 600,
      // 延迟时间
      delay: 200,
      // 动画开始的位置，'bottom', 'left', 'top', 'right'
      origin: 'left',
      // 回滚的时候是否再次触发动画
      reset: true,
      // 在移动端是否使用动画
      mobile: false,
      // 滚动的距离，单位可以用%，rem等
      distance: '200px',
      // 其他可用的动画效果
      opacity: 0.001,
      easing: 'linear'
    })
    this.scrollReveal.reveal(`.right`, {
      // 动画的时长
      duration: 600,
      // 延迟时间
      delay: 200,
      // 动画开始的位置，'bottom', 'left', 'top', 'right'
      origin: 'right',
      // 回滚的时候是否再次触发动画
      reset: true,
      // 在移动端是否使用动画
      mobile: false,
      // 滚动的距离，单位可以用%，rem等
      distance: '200px',
      // 其他可用的动画效果
      opacity: 0.001,
      easing: 'linear'
    })
  },
  methods: {
    goCallUs () {
      const btn = document.getElementById('callusForm')
      const scrollHeight = btn.offsetTop
      window.scrollTo(0, scrollHeight)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/product_page.scss';
.animo-wrap {
  margin: 0 auto;
  position: relative;
  width: 800px;
  height: 800px;
  .lightbeam {
    width: 30px;
    height: 80px;
    transform: perspective(0.5em) rotateX(-5deg);
    background-image: linear-gradient(to top, #61daff, transparent);
  }
  .lightbeam1 {
    position: absolute;
    top: 90px;
    left: 308px;
    animation: box3DAnimo1 2.1s linear infinite;
  }
  .lightbeam2 {
    position: absolute;
    top: 78px;
    right: 168px;
    animation: box3DAnimo1 2.5s linear infinite;
  }
  .lightbeam3 {
    position: absolute;
    top: 266px;
    left: 126px;
    animation: box3DAnimo1 1.8s linear infinite;
  }
  .lightbeam4 {
    position: absolute;
    top: 332px;
    left: 252px;
    animation: box3DAnimo1 2.7s linear infinite;
  }
}
@keyframes box3DAnimo1 {
  0% {
    opacity: 0;
  }
  30% {
    transform: perspective(0.5em) rotateX(-5deg);
    opacity: 1;
  }
  70% {
    transform: perspective(0.5em) rotateX(-5deg);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
